export default "__VITE_ASSET__Czzf7hCh__"